<script setup lang="ts">
  import CloseIcon from '@/shared/assets/icons/CloseIcon.svg';
import { IconImage } from '@/shared/ui';
import { computed } from 'vue';

  const props = withDefaults(defineProps<{
    title?: string;
    textColor?: string;
    titleSize?: string;
  }>(), {
    titleSize: 'text-base',
  });

  const emit = defineEmits<{
    (e: 'close'): void;
  }>();

  const title = computed(() => props.title || '');
  const textColor = computed(() => 'text-' + (props.textColor || '[var(--theme-secondary-ink)]'));
</script>

<template>
  <div
    id="modal-header"
    class="flex justify-between items-center"
  >
    <h1
      class="font-semibold"
      :class="[textColor, titleSize]"
    >
      {{ title }}
    </h1>
    <button
      data-testid="modal-close-button"
      @click="emit('close')"
    >
      <IconImage
        :src="CloseIcon"
        alt="Close"
        class="cursor-pointer"
      />
    </button>
  </div>
</template>
